import React, { Component } from 'react';
import { map, get, size, filter } from 'lodash';
import { Box, Card, Row, HasPermissions, Column, InfoTag, Subtitle, Text, Loading, Icon, FlexContainer } from '../../common';
import DeleteABMGroup from '../../graphql/deleteABMGroup';
import QueryUsers from '../../graphql/getUsers';

export default class ProfileCard extends Component {
    render () {
        const { item, onEdit } = this.props;
        const filters = { field: 'groups', type: 'object', value: [get(item, 'id')] };
        const { id } = item;
        return (
            <Box width={['100%', '50%', '33.33%']}>
                <Card
                    margin={5}
                    leftHeader={() => (
                        <Column>
                            <Text text={get(item, 'alias')} size={13} strong />
                            <Subtitle text={get(item, 'name', '')} color='#848484' />
                        </Column>
                    )}
                    rightHeader={() => (
                        <Row align='center' justify='flex-end'>
                            <InfoTag>
                                <QueryUsers fetchPolicy='network-only' variables={{ filters, size: 10000 }}>
                                    {({ data }) => {
                                        return (
                                            <Subtitle text={size(data)} />
                                        );
                                    }}
                                </QueryUsers>
                                <Icon name='account' size={11} left={5} />
                            </InfoTag>
                            <DeleteABMGroup>
                                {({ loading, deleteFn }) => (
                                    <Loading loading={loading}>
                                        <HasPermissions to={['profiles-page:detail']}>
                                            <Icon name='edit' size={11} left={10} onClick={() => onEdit(item)} pointer />
                                        </HasPermissions>
                                        <HasPermissions to={['profiles-page:delete']}>
                                            <Icon name='trash' size={11} left={10} onClick={() => deleteFn({ variables: { id } })} pointer />
                                        </HasPermissions>
                                    </Loading>
                                )}
                            </DeleteABMGroup>
                        </Row>
                    )}
                    bodyChildren={() => (
                        <FlexContainer direction='column'>
                            <Text text={get(item, 'description')} />
                            <FlexContainer direction='column' mT={10}>
                                <Text strong text='Permisos' />
                                <Row mT={5}>
                                    { map(filter(get(item, 'permissions', []), ({ accesses }) => size(accesses)), ({ id, name, accesses }) => (
                                        <>
                                            <InfoTag key={id}>{`${name}`}</InfoTag>
                                        </>
                                    )) }
                                </Row>
                            </FlexContainer>
                        </FlexContainer>
                    )}
        />
            </Box>
        );
    }
}
